import { Component } from '@angular/core'
import { LogoSize } from '../../logo/ftr/ftr-logo.component'

@Component({
  selector: 'ftr-header-logged-out',
  templateUrl: './header-logged-out.component.html',
  styleUrls: ['./header-logged-out.component.css'],
})
export class HeaderLoggedOutComponent {
  readonly logoSizes = LogoSize
}
